import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledCart = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    flex: 1 1 50%;
  }

  @supports (display: grid) {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;

    > div {
      flex: 0;
    }
  }

  .plans {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    > div {
      flex: 1 1 50%;
    }

    @supports (display: grid) {
      display: grid;
      grid-template-columns: 100px auto;
      grid-column-gap: ${themeGet('scale.scaleUp03')};

      > div {
        flex: 0;
      }
    }
  }

  .plans-packages {
    font-family: "Whitney SSm A", "Whitney SSm B", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-weight: ${themeGet('fontWeight.fontWeightBold')};
  }

  .remove-package {
    line-height: 1;
    cursor: pointer;
    border: none;
    background: transparent;
    padding: ${themeGet('scale.scaleDown04')};
    color: ${themeGet('color.colorGrayBlue60')};
    margin-left: ${themeGet('scale.scaleDown04')};
    vertical-align: 1px;

    svg {
      position: relative;
      top: -1px;
    }

    &:hover {
      color: ${themeGet('color.colorBlue')};
      background: ${themeGet('color.colorGrayBlue10')};
    }
  }

  .total {
    justify-self: end;
    text-align: right;

    span {
      font-size: ${themeGet('scale.scaleDown01')};
      margin-right: 0.5em;
    }

    strong {
      font-size: ${themeGet('scale.scaleUp03')};
    }

    small {
      font-size: ${themeGet('scale.scaleDown02')};
      color: ${themeGet('color.colorGrayBlue70')};
      display: block;
      line-height: 1em;

      @media (max-width: ${themeGet('breakpoint.breakpointMobile')}) {
        margin-top: ${themeGet('scale.scaleDown04')};
      }
    }
  }
`;

export default StyledCart;
